import React, { useEffect, useRef } from "react";

import { Box } from "@chakra-ui/react";

// deklarasi window.sliderCaptcha biar TS gak komplain
declare global {
    interface Window {
        sliderCaptcha?: (opts: any) => { reset: () => void };
    }
}

type Props = {
    isOpen: boolean;
    onSuccess: () => void;
    onClose?: () => void; // optional kalau mau tutup manual
};

const SliderCaptcha: React.FC<Props> = ({ isOpen, onSuccess }) => {
    const elRef = useRef<HTMLDivElement | null>(null);
    const instanceRef = useRef<{ reset: () => void } | null>(null);

    useEffect(() => {
        // init hanya sekali
        if (!elRef.current) return;
        if (instanceRef.current) return;
        if (!window.sliderCaptcha) {
            // kalau belum ke-load, jangan crash
            // bisa kamu ganti jadi toast error
            console.error("sliderCaptcha not loaded");
            return;
        }

        instanceRef.current = window.sliderCaptcha({
            element: elRef.current,
            loadingText: "Loading...",
            failedText: "Try again",
            barText: "Slide right to fill",
            repeatIcon: "fa fa-refresh",
            onSuccess: () => {
                setTimeout(() => {
                    onSuccess();
                    // reset agar siap dipakai ulang
                    instanceRef.current?.reset?.();
                }, 600);
            },
        });
    }, [onSuccess]);

    // Saat ditutup (isOpen false), kita cuma hide. Instance tetap ada (lebih cepat).
    return (
        <Box
            mt={3}
            display={isOpen ? "block" : "none"}
            // biar tidak "nabrak" layout dan rapi
            sx={{
                ".sliderContainer, .slidercaptcha": {
                    width: "100%",
                },
            }}
        >
            <Box ref={elRef} />
        </Box>
    );
};

export default SliderCaptcha;
